import { createSlice } from '@reduxjs/toolkit';

const initState = {
    RoutelistPath: ['dashboard', 'return', 'match-products']
};

export const PermissionRouteSlice = createSlice({
    name: 'permissionRoute',
    initialState: initState,
    reducers: {
        setPermissionRole: (state, action) => {
            let updateRoute = { ...state, ...action.payload };
            return updateRoute;
        },
        resetPermissionRole: () => initState
    }
});

export const { setPermissionRole, resetPermissionRole } = PermissionRouteSlice.actions;

export default PermissionRouteSlice.reducer;
